export default class QueuedMessageError extends Error {
    constructor(message, queueMessage) {
        super(message);
        this.name = "QueuedMessageError";
        this.queueMessage = queueMessage;
    }
}
